// import axios from 'axios';
// import constants from '../constants';
// import authService from '../auth/AuthService';
import moment from 'moment';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/grouptemplate';

export default {
  getAllForGroup(forGroup) {
    return new Promise(function(resolve, reject) {      
      AppUsersClient.get(`${resource}/getAllForGroup/?forGroup=${(forGroup ? forGroup : '')}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },    
  create(groupTemplate) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .post(`${resource}`, groupTemplate)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  update(groupTemplate) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .put(`${resource}`, groupTemplate)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  apply(groupTemplate) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .post(`${resource}/apply`, groupTemplate)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  canApply(groupTemplate) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .post(`${resource}/canApply`, groupTemplate)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  loadGroupTemplateAllocation(dto) {
      return new Promise(function(resolve, reject) {        
        AppUsersClient.get(`${resource}/loadGroupTemplateAllocation/?id=${dto.id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  createGroupTemplateAllocation(dto) {
      return new Promise(function(resolve, reject) {        
        AppUsersClient.post(`${resource}/createGroupTemplateAllocation`, dto)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  updateGroupTemplateAllocation(dto) {
      return new Promise(function(resolve, reject) {        
        AppUsersClient.put(`${resource}/updateGroupTemplateAllocation`, dto)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  deleteGroupTemplateAllocation(dto) {
      return new Promise(function(resolve, reject) {        
        AppUsersClient.post(`${resource}/deleteGroupTemplateAllocation`, dto)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
  rollbackGroupTemplate(groupTemplate) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .post(`${resource}/reverse`, groupTemplate)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};